// extracted by css-extract-rspack-plugin
module.exports =  {"mainPanelContainer":"OCRScopingJobMainPanel__mainPanelContainer___LXwPJ"};